export const STEPPER = {
  ACTIVE: 'active',
  COMPLETE: 'complete',
  NEXT: 'next',
};

export const ADDRESS_TYPE = {
  SHIPPING: 'SHIPPING',
  BILLING: 'BILLING',
};

export const ADDRESS_FORM_UPDATE = 'UPDATE';
export const ADDRESS_FORM_NEW = 'NEW';

export const PURCHASE_ORDER_ATTACHMENT_TYPE = 'PURCHASEORDER';
export const TAX_EXEMPTION_ATTACHMENT_TYPE = 'TAXEXEMPTCERTIFICATE';
export const FILE_ORDER_TYPE = 'SO';
export const TAX_FILE_TITLE = 'Tax Exempt pdf';
export const PO_FILE_TITLE = 'PO pdf';
export const CREDIT_CARD_NAME_FIELD_LENGTH = 40;
export const SEND_TO_ATTENTION_FIELD_LENGTH = 35;
export const BUILDING_DEPARTMENT_LENGTH = 35;
export const STEPPER_SHIPPING_ID = 'shipping';
export const STEPPER_PAYMENT_ID = 'payment';
export const PURCHASE_ORDER_OPTIONAL_LABEL = 'purchase-order-optional-label';
export const TAX_EXEMPT_OPTIONAL_LABEL = 'tax-exempt-optional-label';
export const PHONE_NUMBER_MAX_LENGTH = 35;
export const ATTACHMENT_FILE_TYPE_PATTERN = /(\.pdf)$/i;
export const BILLING_BLOCK_TAX_FILE = 'TC';
export const GENERIC_ERROR_CODE = 'genericError';

export default { STEPPER };

export const PAYMENT_METHOD = {
  PAY_NOW: 'payNow',
  PAY_LATER: 'payLater',
  CREDIT_CARD: 'creditCard',
  BANK_TRANSFER: 'bankTransfer',
  INVOICE: 'invoice',
  BANK: 'bank',
};
